export const SIDEBAR_WIDTH = 265;
